//[Balance Step 10]: Fetch a topup send request para traer el saldo
import { SaleActions } from "../../../presentation/redux/actions/SaleActions";
import { RemoteConstants } from "../../../data/remote/RemoteConstants";

export const balanceRequest2 = (token, value, sku) => async (dispatch) => {

  const tmpObject = {
    web_component: "input-client-balance",
    web_label: "Saldo no disponible",
    web_value: null,
  }

  try {
    const params = new URLSearchParams({
      token,
      sku: sku,
      amount: 0,
      messageType: 10,
      requestFrom: "WEB",
      destination: value,

    });
    const response = await fetch(`${RemoteConstants.BASE_URL}topup/send/request?${params.toString()}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });

    const data = await response.json();

    if (data.code === 'OK') {
      const balanceItem = data.data.find((item) => item.param === 'clientBalance');
      if (balanceItem) {
        dispatch(SaleActions.setClientBalance(balanceItem));
      } else {
        dispatch(SaleActions.setClientBalance(tmpObject));
      }
    } else {
      dispatch(SaleActions.loadingInactiveBalance());
      dispatch(SaleActions.setClientBalance(tmpObject));
    }
  } catch (error) {
    dispatch(SaleActions.setClientBalance(tmpObject));
  }
}
